<template>
    <div class="container-fluid" v-if="time===true">
        <div class="px-0">
            <div class="col-md-6 px-0">
                <v-checkbox
                        v-model="autoSend"
                        label="ارسال خودکار"
                        color="indigo darken-3"
                        :value="autoSend"
                        hide-details
                        class="datePick"
                        inset
                ></v-checkbox>
                <div class="p-4" v-if="autoSend===true">
                    <date-picker v-model="date" type="datetime"
                                 format="YYYY-MM-DD HH:mm"
                                 display-format="jYYYY-jMM-jDD HH:mm"
                                 :timezone="false"
                                 auto-submit
                                 label="ارسال خودکار"
                                 endTime></date-picker>
                </div>
            </div>
            <div class="col-md-6 px-0">
                <v-checkbox
                        v-model="autoRemove"
                        label="حذف خودکار"
                        color="indigo darken-3"
                        :value="autoRemove"
                        hide-details
                        class="datePick"
                        inset
                ></v-checkbox>
                <div class="p-4" v-if="autoRemove===true">
                    <input type="hidden" name="autoSend"/>
                    <date-picker v-model="endTime" auto-submit type="datetime"
                                 format="YYYY-MM-DD HH:mm"
                                 display-format="jYYYY-jMM-jDD HH:mm"
                                 :timezone="false"
                                 label="حذف خودکار"
                                 endTime>
                    </date-picker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Swal from "sweetalert2";
import {Bus} from "@/main";

export default {
    name: "automatics",
    props: {
        AutoSend: {
            required: true,
        },
        multiAds: {
            required: true,
            type: Boolean,
            default: false
        },
        time: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            date: '',
            multi: this.multiAds,
            autoSend: false,
            autoRemove: false,
            NowTime: '',
            endTime: '',
            disabled: '',
            times: {
                starttime: '',
                endtime: '',
            },

        }
    },
    components: {
        DatePicker: VuePersianDatetimePicker
    },
    watch: {
        autoSend(val) {
            this.AutoSend = this.autoSend
            if (val === null) {
                this.times.starttime = ''
                this.date = ''
            }
        },
        autoRemove(val) {
            if (val === null) {
                this.times.endtime = ''
                this.endTime = ''
            }
        },
        date(val) {
            let timeStamp = Date.parse(val);
            const startTime = timeStamp / 1000;
            if (startTime < this.NowTime) {
                Swal.fire({
                    title: 'خطا',
                    text: 'زمان ارسال باید بزرگتر از زمان جاری باشد',
                    icon: 'error',
                    confirmButtonText: 'باشه'
                }).then(() => {
                    this.date = ''
                })
            } else {
                this.AutoSend = this.autoSend;
                this.times.starttime = startTime;
            }
        },
        endTime(val) {
            const EndTime = Date.parse(val) / 1000;
            if (EndTime <= this.NowTime) {
                Swal.fire({
                    title: 'خطا',
                    text: 'زمان پایان باید بزرگتر از زمان جاری باشد',
                    icon: 'error',
                    confirmButtonText: 'باشه'
                }).then(() => {
                    this.endTime = ''
                })
            } else if (this.times.starttime >= EndTime) {
                Swal.fire({
                    title: 'خطا',
                    text: 'زمان پایان باید بزرگتر از زمان ارسال باشد',
                    icon: 'error',
                    confirmButtonText: 'باشه'
                }).then(() => {
                    this.endTime = ''
                })
            } else {
                this.AutoSend = this.autoSend;
                this.times.endtime = EndTime;
            }
        },
        times: {
            handler: function (value) {
                Bus.$emit('times', {
                    times: value,
                    key: this.$vnode.key
                });
            },
            deep: true
        }
    },
    methods: {
        getTimesForNow() {
            $.ajax({
                url: `${url}/setting/clock`,
                type: 'GET',
                fn: this.getTimesForNow,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.NowTime = data.data.time_stamp;
                }
            });
        }
    },
    mounted() {
        this.getTimesForNow();
    },
}
</script>

<style scoped>

</style>